export const testData = ["eggs", "milk", "sugar", "cereal", "cabbage"];
